import { Center, Text } from '@mantine/core';
import * as icons from '@sloyd/icons';
import classes from './GeneratorFeatures.module.css';
import { Wrapper } from './GeneratorFeatures.style';

export type GeneratorFeaturesProps = {
  generator: IGenerator;
};

const mockdata = [
  { id: 'parametersCount', label: 'Parameters', value: 29, icon: 'IconSettings' },
  { id: 'groupsCount', label: 'Groups', value: 7, icon: 'IconUsersGroup' },
  { id: 'slotsCount', label: 'Slots', value: 4, icon: 'IconLayersSubtract' },
];

export function GeneratorFeatures(props: GeneratorFeaturesProps) {
  const { generator } = props;
  const { meta } = generator;

  const features = mockdata.map((feature) => {
    const { id, label, icon } = feature;

    const Cmp = (icons as any)[icon];
    if (!Cmp) return null;

    const value = (meta as any)[id];

    return (
      <Center key={feature.label} className={classes.field}>
        <Cmp size={16} className={classes.icon} stroke={1.5} />
        <Text size='xs'>{label}</Text>
        <Text size='xs'>
          <span>{value}</span>
        </Text>
      </Center>
    );
  });

  return (
    <Wrapper className='GeneratorFeatures-wrapper' data-testid='GeneratorFeatures-wrapper'>
      {features}
    </Wrapper>
  );
}

export default GeneratorFeatures;
